import { createSlice, createAsyncThunk } from "@reduxjs/toolkit";
import axios from "axios";

// Async action to fetch company detail list data
export const getContractorReviewList = createAsyncThunk(
  "contractorReviewList/getContractorReviewList",
  async (data, { rejectWithValue }) => {
    try {
      const response = await axios.post(
        `${process.env.REACT_APP_API_URL}/api/contractor/get_all_review`,
        data,

        {
          headers: {
            "Content-Type": "application/json",
          },
        }
      );

      return response.data;
    } catch (error) {
      return rejectWithValue(error.response?.data || error.message);
    }
  }
);

const contractorReviewSlice = createSlice({
  name: "contractorReviewList",
  initialState: {
    loading: false,
    contractorReviewData: null,
    error: null,
  },
  reducers: {},
  extraReducers: (builder) => {
    builder
      .addCase(getContractorReviewList.pending, (state) => {
        state.loading = true;
        state.error = null;
      })
      .addCase(getContractorReviewList.fulfilled, (state, action) => {
        state.loading = false;
        state.contractorReviewData = action.payload;
      })
      .addCase(getContractorReviewList.rejected, (state, action) => {
        state.loading = false;
        state.contractorReviewData = action.payload;
        state.error = action.payload;
      });
  },
});

export default contractorReviewSlice.reducer;
